var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-box-container"},[_c('div',{ref:"editor",staticClass:"editor"}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveData}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002e6f90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/design/customPage/rich-text-box.vue
// module id = null
// module chunks = 